import axios from "axios";

const apiService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to set the Authorization header
export const setAuthToken = (token) => {
  if (token) {
    apiService.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("accessToken", token);
  } else {
    delete apiService.defaults.headers.common["Authorization"];
    localStorage.removeItem("accessToken");
  }
};

// Function to refresh the access token
const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await apiService.post("/auth/refresh", {
      token: refreshToken,
    });
    const newAccessToken = response.data.token.accessToken;
    setAuthToken(newAccessToken);
    return newAccessToken;
  } catch (error) {
    console.error("Failed to Refresh Token:", error);
    handleLogout();
    throw error;
  }
};

apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiService.interceptors.response.use(
  (response) => {
    console.log("Passed with Access Token");
    return response;
  },
  async (error) => {
    console.log("Refreshing Access Token...");
    console.log(error);
    const originalRequest = error.config;

    if (error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");
      try {
        const newAccessToken = await refreshAccessToken(refreshToken);
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return apiService(originalRequest);
      } catch (refreshError) {
        handleLogout();
        return Promise.reject(refreshError);
      }
    }

    if (error.response?.status === 401) {
      handleLogout();
    }

    return Promise.reject(error);
  }
);

// Function to initialize the token from localStorage on startup
export const initializeToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    setAuthToken(accessToken);
  }
};

// Function to handle logout (clear localStorage, redirect, etc.)
const handleLogout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('isCheckingAuth');
  // You might want to use a global state management solution or context to trigger a redirect
  // For now, we'll just reload the page
  window.location.reload();
};

// Initialize token on startup
//initializeToken();

export default apiService;
